import {useAuth} from "./../../../contexts/AuthContext"
import React, {useState} from "react";
import {Page} from "../../layout/Pages";
import ListViewTable, {ThreeLineColumnWithLink} from "../../elements/tables/ListViewTable";
import {useQuery} from "@tanstack/react-query";
import {PrimaryButton} from "../../elements/Buttons";
import {deleteDocuments, getDocuments} from "../../../api/documents";
import {toast} from "react-toastify";
import classNames from "classnames";


const columns = [
    {
        accessorKey: "id",
        id: "select",
        columnType: "select",
    },
    {
        accessorKey: "client.name",
        id: "client",
        header: "Client",
        enableColumnFilter: true,
        // filterFn: "containsString",
    },
    {
        accessorKey: "title",
        id: "title",
        header: "Title",
        enableColumnFilter: false,
        cell: ({row, value}) => (
            <ThreeLineColumnWithLink
                line1={`${row.original.title}`}
                line2={`${row.original.file_name ? row.original.file_name : ''}`}
                line3={`${row.original.source_url ? row.original.source_url : ''}`}
            />
        )
    },
    {
        accessorKey: "source",
        id: "source",
        header: "Source",
        enableColumnFilter: true,
    },
    {
        accessorKey: "get_status_display",
        id: "get_status_display",
        header: "Status",
        enableColumnFilter: true,
    },
    {
        accessorKey: "source_last_modified_date",
        id: "source_last_modified_date",
        header: "Date modified",
        columnType: "date_time",
        enableColumnFilter: false,
    },
]

export default function DocumentList() {

    const {currentUser, permissions} = useAuth()
    const [rowSelection, setRowSelection] = useState([]);
    const [uploadsOrAll, setUploadsOrAll] = useState("uploads");

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["direct_upload_documents", currentUser.id, uploadsOrAll],
        () => getDocuments(uploadsOrAll),
        {refetchInterval: 1000 *60*2} // 2 minutes
    )

    async function handleDelete() {
        await deleteDocuments(rowSelection)
        toast.success('Documents deleted.')
        setRowSelection([])
        await refetch()
    }

    function getRowLink(row) {
        return `/documents/${row.original.id}/edit`;
    }

    return (
        <Page>
            <div className="px-2">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">Documents</h1>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <PrimaryButton label="Upload document" link={"/documents/new"}/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="sm:-my-2 sm:-mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <nav className="flex space-x-4" aria-label="Tabs">
                                <a
                                    key="uploads"
                                    onClick={() => setUploadsOrAll("uploads")}
                                    className={classNames(
                                        uploadsOrAll === "uploads"
                                            ? "bg-imsblue-100 text-imsblue-700"
                                            : "text-gray-500 hover:text-gray-700",
                                        "px-3 py-2 font-medium text-sm rounded-md cursor-pointer"
                                    )}
                                    aria-current={uploadsOrAll === "uploads" ? "page" : undefined}
                                >
                                    Uploads
                                </a>
                                <a
                                    key="all"
                                    onClick={() => setUploadsOrAll("")}
                                    className={classNames(
                                        uploadsOrAll === ""
                                            ? "bg-imsblue-100 text-imsblue-700"
                                            : "text-gray-500 hover:text-gray-700",
                                        "px-3 py-2 font-medium text-sm rounded-md cursor-pointer"
                                    )}
                                    aria-current={uploadsOrAll === "" ? "page" : undefined}
                                >
                                    All
                                </a>
                            </nav>
                        </div>

                        <div
                            className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    rowSelection={rowSelection}
                                    setRowSelection={setRowSelection}
                                    getRowLink={getRowLink}
                                    onDelete={handleDelete}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}
